module.exports = __webpack_public_path__ + "img/ticket_icon_message.46b84ce6.svg";